import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { classes } from "../../constants";
// import { classesWithIds } from "../../constants";

const NearbyClasses = () => {
  const [searchClass, setSearchClass] = useState("");
  const [resultClasses, setResultClasses] = useState(classes);
  // console.log(classesWithIds);

  const handleSearch = () => {
    try {
      if (searchClass.trim() !== "") {
        const searchResults = classes.filter((classes) => {
          const regex = new RegExp(searchClass, "i");
          return regex.test(classes.name) || regex.test(classes.location);
        });
        setResultClasses(searchResults);
      } else {
        setResultClasses(classes);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [searchClass]);

  return (
    <div class="p-2 bg-white animate-fadeIn">
      <div className="my-3 ml-5">
        <Link to="/">Home</Link> / Music Classes
        <h1 className="text-center text-4xl pb-2 font-bold">Music Classes </h1>
        {/* <p className="text-center text-lg text-gray-600">
          Explore nearby music classes offered in your area. Whether you're
          interested in learning an instrument or improving your vocal skills,
          you'll find a variety of options available.
        </p> */}
        <div className="text-center">
          <p className="text-center text-lg text-gray-600">
            Explore nearby music classes offered in your area. Whether you're
            interested in learning an instrument or improving your vocal skills,
            you'll find a variety of options available.
          </p>
          <div className="flex justify-center items-center">
            <input
              className="border border-black px-4 py-2 rounded-md mr-2 focus:outline-none w-96"
              placeholder="Enter the name or location..."
              type="text"
              onChange={(e) => setSearchClass(e.target.value)}
            />
            {/* <button
              onClick={handleSearch}
              className="bg-blue-950 hover:bg-blue-900 text-white font-semibold py-2 px-4 rounded focus:outline-none"
            >
              Search
            </button> */}
          </div>
        </div>
      </div>
      {resultClasses?.map((item) => (
        <div
          key={item.id}
          class="group mx-2 mt-5 grid max-w-screen-lg grid-cols-1 space-x-8 overflow-hidden rounded-lg border text-gray-700 shadow transition hover:shadow-lg sm:mx-auto sm:grid-cols-5"
        >
          <a
            href="#"
            class="col-span-2 text-left text-gray-600 hover:text-gray-700"
          >
            <div class="group relative h-full w-full overflow-hidden">
              <img
                src={item.image_link}
                alt=""
                class="h-full w-full border-none object-cover text-gray-700 transition group-hover:scale-125"
              />

              <img
                src="/images/AnbWyIjnwNbW9Wz6c_cja.svg"
                class="absolute inset-1/2 w-10 max-w-full -translate-x-1/2 -translate-y-1/2 transition group-hover:scale-125"
                alt=""
              />
            </div>
          </a>
          <div class="col-span-3 flex flex-col space-y-3 pr-8 text-left">
            <a href="#" class="mt-3 overflow-hidden text-2xl font-semibold">
              {" "}
              {item.name}
            </a>

            <div class="mt-5 flex items-center">
              <div class="flex items-center">
                <svg
                  class="block h-4 w-4 align-middle text-yellow-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    class=""
                  ></path>
                </svg>
                <svg
                  class="block h-4 w-4 align-middle text-yellow-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    class=""
                  ></path>
                </svg>
                <svg
                  class="block h-4 w-4 align-middle text-yellow-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    class=""
                  ></path>
                </svg>
                <svg
                  class="block h-4 w-4 align-middle text-yellow-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    class=""
                  ></path>
                </svg>
                <svg
                  class="block h-4 w-4 align-middle text-yellow-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    class=""
                  ></path>
                </svg>
                {item.rating}
              </div>
              <p class="ml-2 text-sm font-medium text-gray-500">
                {item.reviews} Reviews
              </p>
            </div>
            <a
              href="#"
              class="text-sm font-semibold text-gray-500 hover:text-gray-700"
            >
              <LocationOnOutlinedIcon />
              {item.location}
            </a>

            <div class="flex flex-col text-gray-700 sm:flex-row">
              <div class="flex h-fit space-x-2 text-sm font-medium">
                <div class="rounded-full  bg-gray-100 px-2 py-0.5 text-black">
                  Music Classes
                </div>

                <div class="rounded-full bg-gray-100 px-2 py-0.5 text-black">
                  Singing Classes
                </div>
              </div>
            </div>
            <div className="py-5">
              <a
                href={item.actual_link}
                target="_blank"
                rel="noreferrer"
                class="my-5 rounded-md px-5 py-2 m-4 text-center transition hover:scale-105 bg-[#058a07] text-white sm:ml-auto"
              >
                {item?.phone}{" "}
              </a>
              <a
                href={item.actual_link}
                target="_blank"
                rel="noreferrer"
                class="my-5 rounded-md px-3 py-2 m-4 text-center transition hover:scale-105 bg-[#0076d7] text-white sm:ml-auto min-w-[125px]"
              >
                Send Enquiry{" "}
              </a>
              <a
                href={item.actual_link}
                target="_blank"
                rel="noreferrer"
                class="my-5 rounded-md px-5 py-2 m-4 text-center transition hover:scale-105 bg-orange-600 text-white sm:ml-auto"
              >
                Enroll Now{" "}
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NearbyClasses;
